import { DeviceLoader } from './devices';
import { LocationsLoader } from './locations';
import { ViewershipLoader } from './viewership';

export namespace Loaders {
  export const Viewership = ViewershipLoader;
  export const Devices = DeviceLoader;
  export const Locations = LocationsLoader;
}
